module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av677-d4b6aa2c750b4c47e9d19eb985b6a1bf.jpg";